import { InertiaLink } from '@inertiajs/inertia-react'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

const CustomButton = styled(Button)`
  color: rgba(0, 0, 0, 0.87);
`

export default function HeaderComponent() {
  const { t } = useTranslation()
  return (
    <CustomButton color="inherit" component={InertiaLink} href={route('admin.campaigns.create')} variant="contained">
      {t('BUTTON.ADD_CAMPAIGN')}
    </CustomButton>
  )
}
